import "javascripts/slick";

export default class SlickCollection {
  constructor({ element, $element }) {
    this.$element = $element;
    this.element = element;
  }

  init() {
    let slickSlideShow = this.getSlideShow();

    this.$element.slick({
      arrows: true,
      infinite: false,
      speed: 350,
      cssEase: "easeInOut",
      slidesToShow: slickSlideShow,
      slidesToScroll: slickSlideShow,
    });
  }

  getSlideShow() {
    const SLIDE = 5;

    try {
      return parseInt(this.element.dataset.slideShow) || SLIDE;
    } catch (e) {
      return SLIDE;
    }
  }
}
